import Icon1 from "@assets/icons/Icon";
import BaseModal from "@components/modals/BaseModal";
import Button from "@components/ui/buttons/Button";

interface PDFViewerModalProps {
  pdfUrl: string;
  title?: string;
  onClose: () => void;
}

export function PDFViewerModal({
  pdfUrl,
  title = "Document PDF",
  onClose,
}: PDFViewerModalProps) {
  return (
    <BaseModal
      title={title}
      startIcon={<Icon1 name="pdf" size={20} />}
      onClose={onClose}
      display="fullscreen"
      width="max-w-6xl"
    >
      <div className="flex flex-col h-full">
        <div className="flex-1 overflow-hidden" style={{ height: "calc(100vh - 120px)" }}>
          <iframe
            src={pdfUrl}
            className="w-full h-full"
            title={title}
          />
        </div>
        <div className="border-t-1 p-4 flex flex-row justify-end gap-2">
          <Button
            variant="small"
            label="Télécharger"
            onClick={() => window.open(pdfUrl, "_blank")}
          />
        </div>
      </div>
    </BaseModal>
  );
}
